module.exports = __webpack_public_path__ + "static/media/v3m.c6da3884.mp4";